/**
 * The modules a preset can place. To add one: write it in its own folder here, add a line below,
 * then put its id in a preset.
 */
import type { ModuleDefinition } from './contract';
import { AvatarOrb, AvatarPortrait } from './avatar/AvatarModule';
import { AvatarWindowModule } from './avatar-window/AvatarWindowModule';
import { ChatModule } from './chat/ChatModule';
import { LyricsChat } from './chat/LyricsChat';
import { ComposerModule, PillComposer } from './composer/ComposerModule';
import { ContentModule } from './content/ContentModule';
import { MainBarModule, PillsBar } from './main-bar/MainBarModule';
import { MinimalTopBar } from './progress/MinimalTopBar';
import { ProgressModule } from './progress/ProgressModule';
import { MinimalFooter } from './status/MinimalFooter';
import { StatusModule } from './status/StatusModule';

export const BUILTIN_MODULES: readonly ModuleDefinition[] = [
  {
    id: 'progress', label: 'module.progress', interactive: false, fullBleed: true, Component: ProgressModule,
    variants: [{ id: 'minimal', label: 'module.variant.minimal_top', Component: MinimalTopBar }],
  },
  {
    id: 'chat', label: 'module.chat', interactive: false, Component: ChatModule,
    variants: [{ id: 'lyrics', label: 'module.variant.lyrics', Component: LyricsChat }],
  },
  {
    id: 'composer', label: 'module.composer', interactive: true, Component: ComposerModule,
    variants: [{ id: 'pill', label: 'module.variant.pill_composer', Component: PillComposer }],
  },
  {
    id: 'avatar', label: 'module.avatar', interactive: false, Component: AvatarOrb,
    variants: [
      { id: 'portrait', label: 'module.variant.portrait', Component: AvatarPortrait },
    ],
  },
  { id: 'avatar-window', label: 'module.avatar_window', interactive: false, Component: AvatarWindowModule },
  { id: 'content', label: 'module.content', interactive: true, Component: ContentModule },
  {
    id: 'main-bar', label: 'module.main_bar', interactive: true, fullBleed: true, Component: MainBarModule,
    variants: [{ id: 'pills', label: 'module.variant.pills', Component: PillsBar }],
  },
  {
    id: 'status', label: 'module.status', interactive: true, fullBleed: true, Component: StatusModule,
    variants: [{ id: 'minimal', label: 'module.variant.minimal_footer', Component: MinimalFooter }],
  },
];
